/**
 * SupplierService
 * Service for Supplier entity operations
 * Route: api/suppliers
 */
import { CrudService } from '../base/CrudService';
/**
 * SupplierService
 * Handles supplier CRUD operations
 */
export class SupplierService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? SupplierService.DEFAULT_SERVICE_PATH,
            basePath: SupplierService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== CUSTOM METHODS ====================
    /**
     * Search suppliers by name
     * @param name - Search term
     * @returns Array of matching suppliers
     */
    async searchByName(name) {
        const response = await this.searchByNameRaw(name);
        return response.data ?? [];
    }
    /**
     * Search suppliers by name (raw)
     * @param name - Search term
     * @returns ResponseData with matching suppliers
     */
    searchByNameRaw(name) {
        const endpoint = this.getEndpoint('search', 'search');
        const url = this.buildUrl(endpoint);
        const params = new URLSearchParams({ name });
        return this.http.get(`${url}?${params}`);
    }
    /**
     * Get suppliers by industry
     * @param industryId - Industry ID (optional)
     * @returns Array of suppliers
     */
    async getByIndustry(industryId) {
        const response = await this.getByIndustryRaw(industryId);
        return response.data ?? [];
    }
    /**
     * Get suppliers by industry (raw)
     * @param industryId - Industry ID (optional)
     * @returns ResponseData with suppliers
     */
    getByIndustryRaw(industryId) {
        const url = this.buildUrl();
        const params = new URLSearchParams();
        if (industryId !== undefined) {
            params.append('industryId', industryId.toString());
        }
        return this.http.get(`${url}?${params}`);
    }
    /**
     * Get suppliers by active status
     * @param active - Active status
     * @returns Array of suppliers
     */
    async getByActiveStatus(active) {
        const response = await this.getByActiveStatusRaw(active);
        return response.data ?? [];
    }
    /**
     * Get suppliers by active status (raw)
     * @param active - Active status
     * @returns ResponseData with suppliers
     */
    getByActiveStatusRaw(active) {
        const url = this.buildUrl();
        const params = new URLSearchParams({ active: active.toString() });
        return this.http.get(`${url}?${params}`);
    }
    // ==================== VIEW METHODS ====================
    async getAllViews() {
        const response = await this.getAllViewsRaw();
        return response.data ?? [];
    }
    getAllViewsRaw() {
        const url = this.buildUrl('views');
        return this.http.get(url);
    }
    async getViewById(id) {
        const response = await this.getViewByIdRaw(id);
        return response.data ?? null;
    }
    getViewByIdRaw(id) {
        const url = this.buildUrl(`views/${id}`);
        return this.http.get(url);
    }
}
SupplierService.DEFAULT_SERVICE_PATH = 'suppliers';
SupplierService.BASE_PATH = 'api/suppliers';
//# sourceMappingURL=SupplierService.js.map